import React from "react";
import "./Impact.css";

import icon1 from "../../../../assets/images/work/i1.png";
import icon2 from "../../../../assets/images/work/i2.png";
import icon3 from "../../../../assets/images/work/i3.png";
import icon4 from "../../../../assets/images/work/i4.png";

const Impact = () => {
  return (
    <section className="whyus">

      {/* TOP */}
      <div className="whyus-top">
        <p className="whyus-subtitle">Impact</p>

        <h2 className="whyus-title">
          What our work delivers
        </h2>

        <p className="whyus-description">
          We focus on outcomes that matter – performance, scalability, and real user value.
        </p>
      </div>

      {/* CARDS */}
      <div className="whyus-bottom">

        <div className="why-card">
          <div className="iconwhc">
            <img src={icon1} alt="speed" />
          </div>
          <h3>Speed</h3>
          <p>We move fast without sacrificing quality.</p>
        </div>

        <div className="why-card">
          <div className="iconwhc">
            <img src={icon2} alt="scalability" />
          </div>
          <h3>Scalability</h3>
          <p>Everything we build is designed to grow.</p>
        </div>

        <div className="why-card">
          <div className="iconwhc">
            <img src={icon3} alt="clarity" />
          </div>
          <h3>Clarity</h3>
          <p>We simplify complexity into actionable solutions.</p>
        </div>

        <div className="why-card">
          <div className="iconwhc">
            <img src={icon4} alt="partnership" />
          </div>
          <h3>Partnership</h3>
          <p>We work with you, not just for you.</p>
        </div>

      </div>

    </section>
  );
};

export default Impact;